/* eslint-disable eqeqeq */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-redundant-roles */

import React from "react";
import { req } from "hf-rt";
import checkoutInstore from "../../images/eshop/checkout/checkout-instore.svg";
import checkoutInstoreActive from "../../images/eshop/checkout/checkout-instore-active.svg";
import checkoutLocalDelivery from "../../images/eshop/checkout/checkout-local-delivery.svg";
import checkoutLocalDeliveryActive from "../../images/eshop/checkout/checkout-local-delivery-active.svg";
import paymentVisa from "../../images/eshop/checkout/payment-visa.jpg";
import paymentMastercard from "../../images/eshop/checkout/payment-mastercard.jpg";
import paymentPaypal from "../../images/eshop/checkout/paypal_logo.png";
import paymentStripe from "../../images/eshop/checkout/visa_master_ae_union.png";
import paymentJCB from "../../images/eshop/checkout/JCB_logo.png";
import paymentPps from "../../images/eshop/checkout/payment-pps.jpg";
import paymentUnionpay from "../../images/eshop/checkout/payment-unionpay.jpg";
import paymentAlipay from "../../images/eshop/checkout/payment-alipay.jpg";
import paymentAe from "../../images/eshop/checkout/payment-ae.jpg";
import OrderSummary from "./OrderSummary";
import ChangeDeliveryAddress from "../ChangeDeliveryAddress";
import { connect } from "react-redux";
import PayForm from "../PayForm";
import PayPalButtonWrap from "./PayPalButtonWrap";
import CheckEmail from "./CheckEmail";
import { Translation } from "react-i18next";
import writeCookie from "../../function/writeCookie";
import { proxyErrorText } from "../../function/proxyErrorText";
import isArray from "../../function/isArray";
import {
  stripeErrorMessageTc,
  stripeErrorMessageEn
} from "../../function/stripeErrorMessage";

//models
import { myBag } from "../../models";
import {
  addresses,
  countryList,
  loading,
  pickUpInStore,
  loginPopup,
  customer
} from "../../models";

import { HOST_URL, ASIA_PAY_SHOW, ROOT } from "../../constants";
import TempOrderErrorPopup from "../TempOrderErrorPopup";
import ShoppingBagNum from "./ShoppingBagNum";
import PdtWrap from "./PdtWrap";
import EmptyBag from "./EmptyBag";
import Step2ShippingFee from "./Step2ShippingFee";
import DutyTax from "./DutyTax";
import BtnCheckLogin from "./BtnCheckLogin";
import AddressList from "./AddressList";
import StoreForm from "./StoreForm";
import AddressFrom from "./AddressFrom";
import { setGAEvent } from "../../function/setGAEvent";

import masterSvg from "../../images/eshop/checkout/svg/mastercard.svg";
import visaSvg from "../../images/eshop/checkout/svg/visa.svg";
import amexSvg from "../../images/eshop/checkout/svg/amex.svg";
import unionSvg from "../../images/eshop/checkout/svg/unionpay.svg";

let $ = window.$;
let stripe;
// let elements;
let cardNumber;
let cardExpiry;
let cardCvc;

class Collapse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTempOrderFailByOutOfStock: false,
      showTempOrderFail: false,
      places: {},
      deliverOption_btn_active: true,
      index: {
        area: 0,
        district: 0,
        store: 0
      },
      pickupOption: {
        pickup_stores: {
          value: "",
          error: false
        },
        pickup_customerTitle: {
          value: "",
          error: false
        },
        pickup_customerName: {
          value: "",
          error: false
        },
        pickup_phoneCode: {
          value: "+852",
          error: false
        },
        pickup_phoneNo: {
          value: "",
          error: false
        }
      },
      deliveryOption: {
        delivery_address_radioGrp: {
          value: "",
          error: false
        },
        delivery_addrList_empty: false,
        delivery_mode_radioGrp: true,
        delivery_taxPay_radioGrp: "delivery_taxPay1",
        delivery_customerName: {
          value: "",
          error: false
        },
        delivery_phoneCode: {
          value: "+852",
          error: false
        },
        delivery_phoneNo: {
          value: "",
          error: false
        },
        delivery_addressLine1: {
          value: "",
          error: false
        },
        delivery_addressLine2: {
          value: "",
          error: false
        },
        delivery_area: {
          value: "",
          error: false
        },
        delivery_customerTitle: {
          value: "",
          error: false
        },
        delivery_postcode: {
          value: "",
          error: false
        },
        delivery_district: {
          value: "",
          error: false
        },
        delivery_city: {
          value: "",
          error: false
        }
      },
      addressMode: "new",
      addressId: null,
      paymentMethod: "",
      paymentMethodError: false,
      tempOrderResponseData: {
        ctId: "",
        mpsMode: "",
        currCode: "",
        amount: 0,
        lang: "",
        cancelUrl: "",
        failUrl: "",
        successUrl: "",
        merchantId: "",
        payType: "",
        payMethod: "",
        asiapayUrl: "",
        secureHash: ""
      },
      CheckEmailStatus: false,
      CheckEmailDisplayStatus: false,
      stockData: [],
      disableBuyButton: false,
      activePaymentSection: null,
      stripeTrade: null,
      stripeErrorText: null,
      billingName: "",
      cardEvent: { brand: "" },
      activeCardId: null,
      saveCard: false,
      saveCardErrorText: false,
      stripeCards: null
    };
  }
  hasCity(places, deliveryOption) {
    var city = false;

    if (places.items) {
      places.items.forEach((area, index) => {
        if (area.name === deliveryOption.delivery_district.value) {
          city = area.hasOwnProperty("subitems");
        }
      });
    }
    return city;
  }
  isHK() {
    if (this.state.deliveryOption.delivery_area.value === "HK") {
      return true;
    }
    return false;
  }
  async clickEditAddress(address) {
    $("#cancelSaveAdd_btn").show();
    $(".checkout_sect .delivery_newAddress_wrap").slideDown();
    $(".checkout_sect .delivery_details_wrap").slideUp();
    this.setState({
      addressMode: "edit",
      addressId: address.id,
      deliveryOption: {
        ...this.state.deliveryOption,
        delivery_customerName: {
          value: address.rcptFirstNam,
          error: false
        },
        delivery_phoneCode: {
          value: address.rcptMobCtryCde,
          error: false
        },
        delivery_phoneNo: {
          value: address.rcptMobNbr,
          error: false
        },
        delivery_addressLine1: {
          value: address.address1,
          error: false
        },
        delivery_addressLine2: {
          value: address.address2,
          error: false
        },
        delivery_area: {
          value: address.countryCode,
          error: false
        },
        delivery_customerTitle: {
          value: address.rcptSl,
          error: false
        },
        delivery_postcode: {
          value: address.postCode,
          error: false
        },
        delivery_district: {
          value: address.province,
          error: false
        },
        delivery_city: {
          value: address.city,
          error: false
        }
      }
    });

    // 1. 編輯地址時發送國家
    const data = await this.fetchPlaces(address.countryCode);
    if (data.hasOwnProperty("items") && data.items.length > 0) {
      // 2.這個國家有城市的選項時set palces
      this.setState({
        places: data
      });
    } else {
      // 3.沒有城市的選項就清空palces
      this.setState({
        places: {}
      });
    }
  }
  isRemoveSelectedRadio(removeAddrId, selectedAddrId) {
    if (removeAddrId === selectedAddrId) {
      //刪除的選項是已經選擇的選項, 清空delivery_address_radioGrp

      const name = "delivery_address_radioGrp";
      const value = "";
      this.setDeliveryOption(name, value, this.state.deliveryOption);
    }
  }
  clickRemoveAddress = async address => {
    const { removeAddress, fetchAddresses, addresses } = this.props;

    // this.isRemoveSelectedRadio(
    //   address.id,
    //   this.state.deliveryOption.delivery_address_radioGrp.value
    // );

    // 1. 刪除地址
    await removeAddress(address);
    // 2. 重新抓取新的addresses
    await fetchAddresses();
    // 3. 更新目前顯示的預設值
    if (addresses._embedded.addresses.length > 0) {
      // 如果有其他地址選擇第一筆作為預設
      const defaultAddressId = await addresses._embedded.addresses[0].id;

      await this.setState({
        deliveryOption: {
          ...this.state.deliveryOption,
          delivery_address_radioGrp: {
            ...this.state.deliveryOption.delivery_address_radioGrp,
            value: defaultAddressId
          }
        }
      });
      // 發送 Delivery API
      await this.fetchDeliveries({ addressId: defaultAddressId });
    } else {
      // 清空 delivery_address_radioGrp，並顯示錯誤 提示用戶必須新增至少一筆地址

      await this.setState({
        deliveryOption: {
          ...this.state.deliveryOption,
          delivery_address_radioGrp: {
            ...this.state.deliveryOption.delivery_address_radioGrp,
            value: "",
            error: true
          }
        }
      });
    }
  };
  clickNewAdd() {
    this.setState({
      addressMode: "new",
      addressId: null,
      deliveryOption: {
        ...this.state.deliveryOption,
        delivery_customerName: {
          value: "",
          error: false
        },
        delivery_phoneCode: {
          value: "+852",
          error: false
        },
        delivery_phoneNo: {
          value: "",
          error: false
        },
        delivery_addressLine1: {
          value: "",
          error: false
        },
        delivery_addressLine2: {
          value: "",
          error: false
        },
        delivery_area: {
          value: "",
          error: false
        },
        delivery_customerTitle: {
          value: "",
          error: false
        },
        delivery_postcode: {
          value: "",
          error: false
        },
        delivery_district: {
          value: "",
          error: false
        },
        delivery_city: {
          value: "",
          error: false
        }
      }
    });
  }
  payDollar(data) {
    // 原先執行的事件
    $(document).ready(function () {
      try {
        $("#payForm").submit();
      } catch {
        console.log("0---Error----");
      }
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps === this.props) {
      return true;
    }
    Object.keys(this.props).forEach(function (key) {
      // console.log(`now[${key}] === next[${key}]`, now[key] === next[key]);
    });
    return true;
  }
  async componentDidMount() {
    const { fetchCountryIncludeHK, fetchInStore } = this.props;
    fetchCountryIncludeHK();
    // 取得分店資訊的API
    await fetchInStore();
  }

  closeCheckEmailPage = () => {
    this.setState({
      CheckEmailDisplayStatus: false
    });
  };

  closeCheckEmailButton = () => {
    this.setState({
      CheckEmailStatus: false
    });
  };

  async componentDidUpdate(prevProps, prevState) {
    const { addresses } = this.props;

    if (this.state.deliveryOption.delivery_addrList_empty === true) {
      const addressList =
        (addresses._embedded && addresses._embedded.addresses) || [];

      if (addressList.length > 0) {
        this.setState({
          deliveryOption: {
            ...this.state.deliveryOption,
            delivery_addrList_empty: false,
            delivery_address_radioGrp: {
              value: addresses._embedded.addresses[0].id //設定第一筆default selected
            }
          }
        });
      }
    }
  }

  proxyErrorStyle(error, style) {
    // return (error && `error ${style}`) || ((style && style) || null);
  }
  proxyErrorText(error, text) {
    // const defaultTxt = (
    //   <Translation>{t => <>{t("checkout.required")}</>}</Translation>
    // );
    // return (
    //   (error && (
    //     <span className="text-error">{(text && text) || defaultTxt}</span>
    //   )) ||
    //   null
    // );
  }
  async fetchDeliveries(id) {
    const { addressData } = this.props;
    if (id.addressId) {
      const activeAddress = addressData._embedded.addresses.find(
        data => data.id === id.addressId
      );
      const {
        address1,
        address2,
        city,
        countryCode,
        postCode,
        province,
        rcptFirstNam,
        rcptMobCtryCde,
        rcptMobNbr,
        rcptSl
      } = activeAddress;

      const editedDeliveryOption = {
        ...this.state.deliveryOption,
        delivery_addressLine1: { value: address1, error: false },
        delivery_addressLine2: { value: address2, error: false },
        delivery_address_radioGrp: {
          value: id.addressId,
          error: false
        },
        delivery_area: { value: countryCode, error: false },
        delivery_city: { value: city, error: false },
        delivery_customerName: {
          value: rcptFirstNam,
          error: false
        },
        delivery_customerTitle: { value: rcptSl, error: false },
        delivery_district: { value: province, error: false },
        delivery_mode_radioGrp: true,
        delivery_phoneCode: { value: rcptMobCtryCde, error: false },
        delivery_phoneNo: { value: rcptMobNbr, error: false },
        delivery_postcode: { value: postCode, error: false }
      };
      this.setState({
        deliveryOption: editedDeliveryOption
      });
    } else {
    }
    if (id.addressId !== "") {
      //計算運費及預估時間
      await fetch(`${HOST_URL}/shopping/v1/compositions/deliveries`, {
        credentials: "include",
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(id)
      });
    }
    const countryCode = this.state.deliveryOption.delivery_area.value;
    writeCookie("countryCode", countryCode);
  }
  async handlePickupChange(e) {
    const { name } = e.target;
    const { fetchMyBag } = this.props;

    await this.setState({
      pickupOption: {
        ...this.state.pickupOption,
        [e.target.name]: {
          ...this.state.pickupOption[e.target.name],
          value: e.target.value
        }
      }
    });
    if (name === "pickup_stores") {
      if (this.state.pickupOption.pickup_stores.value !== "") {
        await this.fetchDeliveries({
          storeId: this.state.pickupOption.pickup_stores.value.substr(0, 3)
        });
      }

      await fetchMyBag();
    }
  }
  getItem(items, value) {
    const matching = items.find(item => item.name === value);
    return matching;
  }
  setHKPostcoode(places, deliveryOption) {
    const district = this.getItem(
      places.items,
      deliveryOption.delivery_district.value
    );

    const city = this.getItem(
      district.subitems,
      deliveryOption.delivery_city.value
    );

    this.setDeliveryOption(
      "delivery_postcode",
      city.postalCode,
      deliveryOption
    );
  }
  async fetchPlaces(value) {
    const region = value;
    const data = await req.get({
      api: "places",
      params: region
    });
    return data;
  }

  async resetPlaces(data, deliveryOption, value) {
    await this.setState({
      places: data,
      //切換國家, 要重新reset 區域, 城市, postcode
      deliveryOption: {
        ...deliveryOption,
        delivery_area: {
          ...deliveryOption.delivery_area,
          value: value
        },
        delivery_city: {
          ...deliveryOption.delivery_city,
          value: ""
        },
        delivery_district: {
          ...deliveryOption.delivery_district,
          value: ""
        },
        delivery_postcode: {
          ...deliveryOption.delivery_postcode,
          value: ""
        }
      }
    });
  }
  async setDeliveryOption(name, value, deliveryOption) {
    await this.setState({
      deliveryOption: {
        ...deliveryOption,
        [name]: {
          ...deliveryOption[name],
          value: value
        }
      }
    });
  }
  async handleDeliveryChange(e, countryCode) {
    const { name, value } = e.target;
    const { places, deliveryOption } = this.state;
    const { fetchMyBag, startLoading, fetchDutyTax } = this.props;

    //國家選項改變
    if (name === "delivery_area") {
      if (value !== "") {
        writeCookie("country", value);
        const data = await this.fetchPlaces(value);
        await this.resetPlaces(data, deliveryOption, value);
      }
    } else {
      await this.setDeliveryOption(name, value, deliveryOption);
    }

    if (this.isHK() && name === "delivery_city")
      await this.setHKPostcoode(places, this.state.deliveryOption);

    if (name === "delivery_address_radioGrp") {
      // 切換地址時顯示1秒的Loading畫面
      startLoading(true);
      await this.fetchDeliveries({
        addressId: value
      });
      await fetchMyBag();
      //呼叫dutyTax API 取得delivery date
      if (countryCode !== "HK") {
        await fetchDutyTax(countryCode);
      }
      setTimeout(() => {
        startLoading(false);
      }, 1000);
    }
  }

  // 驗證信箱的按鈕事件
  clickNextButtonForCheckEmail = emailState => {
    if (emailState === "P") {
      const pathLang = this.props.lang === "en" ? "en" : "tc";
      window.location.href = `${ROOT}/${pathLang}/verificationEmail`;
      return;
    }
    this.setState({
      CheckEmailDisplayStatus: true
    });
  };

  goStep3() {
    // 滑動至第三步驟效果
    $(".checkout_sect.checkout_payment.step3").addClass("opened");
    const step3Position = document.getElementById("step3-title").offsetTop;
    const step2Height =
      document.getElementById("step2-sect-content").offsetHeight;
    const width = document.body.offsetWidth;
    let stopPosition;
    if (width > 767) {
      stopPosition = step3Position - step2Height + 221.75 - 16;
    } else {
      stopPosition = step3Position - step2Height - 16;
    }
    window.scrollTo({
      top: stopPosition,
      behavior: "smooth"
    });
  }

  async clickNextBtnOfDelivery() {
    //離開前, 檢查所有選項, 若選項有null, 則設定default值或是顯示提示。
    var disableBtn = false;
    const { addresses } = this.props;
    const addressList =
      (addresses._embedded && addresses._embedded.addresses) || [];

    //載入位址為空陣列
    if (addressList.length === 0) {
      await this.setState({
        deliveryOption: {
          ...this.state.deliveryOption,
          delivery_addrList_empty: true
        }
      });

      //disable btn
      disableBtn = true;
    } else if (
      //載入位址陣列大於1筆, 且沒有選擇
      this.state.deliveryOption.delivery_address_radioGrp.value === ""
    ) {
      await this.setState({
        deliveryOption: {
          ...this.state.deliveryOption,
          delivery_address_radioGrp: {
            value: "",
            error: true
          }
        }
      });
      //disable btn
      disableBtn = true;
    } else {
      await this.setState({
        deliveryOption: {
          ...this.state.deliveryOption,
          delivery_address_radioGrp: {
            ...this.state.deliveryOption.delivery_address_radioGrp,
            error: false
          }
        }
      });
    }

    if (disableBtn === true) {
      $(".checkout_payment .sectContent").hide();
      const title = document.getElementById("step2-title");
      window.scrollTo({ top: title.offsetTop, behavior: "smooth" });
    } else {
      $(".checkout_deliver").removeClass("opened");
      $(".checkout_deliver").addClass("filled");
      $(".checkout_payment .sectContent").slideDown(300);
      $(".checkout_deliver .sectContent").slideUp(300);

      this.goStep3();
      // 再執行一次delivery以及mybag
      const addressId =
        this.state.deliveryOption.delivery_address_radioGrp.value;
      this.fetchDeliveries({ addressId });
      this.props.fetchMyBag();
      setGAEvent(
        "add_shipping_info",
        this.props.myBagData,
        this.state.deliverOption_btn_active
      );
    }
  }
  async clickNextBtnOfPickup() {
    //離開前, 檢查所有選項, 若選項有null, 則設定default值或是顯示提示。
    var disableBtn = false;

    if (this.state.pickupOption["pickup_phoneNo"].value !== "") {
      const phoneRegExp =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
      //如果phone Number不是數字則報錯
      let result = phoneRegExp.test(
        this.state.pickupOption["pickup_phoneNo"].value
      );

      if (result === false) {
        //disable btn
        await this.setState({
          pickupOption: {
            ...this.state.pickupOption,
            pickup_phoneNo: {
              ...this.state.pickupOption.pickup_phoneNo,
              phoneNoCanNotHaveTextError: true
            }
          }
        });
        disableBtn = true;
      } else {
        await this.setState({
          pickupOption: {
            ...this.state.pickupOption,
            pickup_phoneNo: {
              ...this.state.pickupOption.pickup_phoneNo,
              phoneNoCanNotHaveTextError: false
            }
          }
        });
        disableBtn = false;
      }
    }

    for (var key in this.state.pickupOption) {
      if (this.state.pickupOption[key].value === "") {
        await this.setState({
          pickupOption: {
            ...this.state.pickupOption,
            [key]: { ...this.state.pickupOption[key], error: true }
          }
        });
        //disable btn
        disableBtn = true;
      } else {
        await this.setState({
          pickupOption: {
            ...this.state.pickupOption,
            [key]: { ...this.state.pickupOption[key], error: false }
          }
        });
      }
    }
    if (disableBtn === true) {
      $(".checkout_payment .sectContent").hide();
      const title = document.getElementById("step2-title");
      window.scrollTo({ top: title.offsetTop, behavior: "smooth" });
    } else {
      $(".checkout_deliver").removeClass("opened");
      $(".checkout_deliver").addClass("filled");
      $(".checkout_payment .sectContent").slideDown(300);
      $(".checkout_deliver .sectContent").slideUp(300);

      this.goStep3();
      setGAEvent(
        "add_shipping_info",
        this.props.myBagData,
        this.state.deliverOption_btn_active
      );
    }
  }
  clickDeliveryMode() {
    this.setState({
      deliveryOption: {
        ...this.state.deliveryOption,
        delivery_mode_radioGrp:
          !this.state.deliveryOption.delivery_mode_radioGrp
      }
    });
  }
  getOptions(items, optionName) {
    items.map((item, index) => {
      const name = item.name;
      this.setState({
        index: {
          [optionName]: index
        }
      });
      return <option value={name}>{name}</option>;
    });
  }
  async saveAdd() {
    var disableBtn = false;
    const { deliveryOption, addressId, addressMode } = this.state;

    const {
      fetchAddresses,
      newAddress,
      editAddress,
      fetchMyBag,
      fetchDutyTax
    } = this.props;

    const address = {
      rcptMobCtryCde: deliveryOption.delivery_phoneCode.value,
      rcptMobNbr: deliveryOption.delivery_phoneNo.value,
      rcptSl: deliveryOption.delivery_customerTitle.value,
      rcptFirstNam: deliveryOption.delivery_customerName.value,
      rcptLastNam: "",
      address2: deliveryOption.delivery_addressLine2.value,
      address1: deliveryOption.delivery_addressLine1.value,
      postCode: deliveryOption.delivery_postcode.value,
      province: deliveryOption.delivery_district.value,
      city: deliveryOption.delivery_city.value,
      type: "S",
      country: deliveryOption.delivery_area.value
    };

    //儲存前檢查所有選項
    for (var key in this.state.deliveryOption) {
      if (
        key !== "delivery_addrList_empty" &&
        key !== "delivery_address_radioGrp" &&
        key !== "delivery_mode_radioGrp" &&
        key !== "delivery_taxPay_radioGrp" &&
        key !== "delivery_addressLine2" &&
        (key !== "delivery_postcode" || !this.isHK())
      ) {
        if (this.state.deliveryOption[key].value === "") {
          await this.setState({
            deliveryOption: {
              ...this.state.deliveryOption,
              [key]: {
                ...this.state.deliveryOption[key],
                error: true
              }
            }
          });
          //disable btn
          disableBtn = true;
        } else {
          await this.setState({
            deliveryOption: {
              ...this.state.deliveryOption,
              [key]: {
                ...this.state.deliveryOption[key],
                error: false
              }
            }
          });
        }
      }
    }
    if (disableBtn === true) {
    } else {
      $(".checkout_sect .delivery_newAddress_wrap").slideUp();
      $(".checkout_sect .delivery_details_wrap").slideDown();
      //儲存一筆新增address
      if (addressMode === "new") {
        // POST 新增的地址出去
        await newAddress(address);
        // GET 新的地址資料
        await fetchAddresses();
        // 從GET回來的新資料抓addressId
        const addressId = this.props.addressData._embedded.addresses[0].id;
        // POST addressId出去
        await this.fetchDeliveries({ addressId });
      } else {
        //儲存一筆編輯位址
        await editAddress(address, addressId);
        await fetchAddresses();
        await this.fetchDeliveries({ addressId: addressId });
      }
      await fetchMyBag();
      //呼叫dutyTax API 取得delivery date
      if (address.country !== "HK") {
        await fetchDutyTax(address.country);
      }
    }
  }
  clickLogin() {
    this.props.showLoginPopup(true);
    // POST MESSAGE 通知 Header 顯示 Login 元件
    window.postMessage("OPEN_LOGIN", "*");
    if (document.body.offsetWidth <= 767) {
      $("#modal_mobileNav").modal("show");
    }
  }

  clearSelectAddress = () => {
    this.setState({
      deliveryOption: {
        ...this.state.deliveryOption,
        delivery_customerName: {
          value: "",
          error: false
        },
        delivery_phoneCode: {
          value: "+852",
          error: false
        },
        delivery_phoneNo: {
          value: "",
          error: false
        },
        delivery_addressLine1: {
          value: "",
          error: false
        },
        delivery_addressLine2: {
          value: "",
          error: false
        },
        delivery_area: {
          value: "",
          error: false
        },
        delivery_customerTitle: {
          value: "",
          error: false
        },
        delivery_postcode: {
          value: "",
          error: false
        },
        delivery_district: {
          value: "",
          error: false
        },
        delivery_city: {
          value: "",
          error: false
        }
      }
    });
  };
  getAddressId(addressList) {
    if (addressList.length <= 0) return "";
    if (this.state.deliveryOption.delivery_address_radioGrp.value === "")
      return addressList[0].id;
    return this.state.deliveryOption.delivery_address_radioGrp.value;
  }
  async clickPickStoreBtn() {
    const { fetchMyBag } = this.props;

    this.setState({
      deliverOption_btn_active: !this.state.deliverOption_btn_active
    });
    //點選到分店取貨button，如果尚未選擇分店地址（下拉式選單未選擇），需要清除運費，清除完再呼叫API myBag

    if (this.state.pickupOption.pickup_stores.value === "") {
      try {
        await fetch(
          `${HOST_URL}/shopping/v1/carts/shippingFeeAndDeliveryDate`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json"
            },
            credentials: "include"
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        await fetchMyBag();
      }
    } else {
      //點選到分店取貨button，如果已選擇分店地址，需要發API deliveries, myBag
      await this.fetchDeliveries({
        storeId: this.state.pickupOption.pickup_stores.value
      });
      await fetchMyBag();
    }
  }
  async clickDeliveryBtn() {
    const { addresses, fetchMyBag, fetchDutyTax } = this.props;
    //客戶的地址陣列
    const addressList =
      (addresses._embedded && addresses._embedded.addresses) || [];

    //初始地址的id
    const addressId = this.getAddressId(addressList);
    //初始地址
    const defaultAddress = addressList.find(
      address => address.id === addressId
    );
    //初始地址的countryCode
    const countryCode = defaultAddress ? defaultAddress.countryCode : "";

    this.setState({
      deliverOption_btn_active: !this.state.deliverOption_btn_active
    });
    if (addressId !== "") {
      //載入初始選擇地址, 將初始地址送到後端, 發delivery API
      await this.fetchDeliveries({
        addressId
      });
    }
    //發mybag取得此筆地址所需的運費, 和到貨日期
    await fetchMyBag();
    //呼叫dutyTax API 取得delivery date
    if (addressId !== "" && countryCode !== "HK") {
      await fetchDutyTax(countryCode);
    }
  }
  goToSuccessPage(data) {
    this.props.startLoading(false);
    this.setState({
      ...this.state,
      tempOrderResponseData: data
    });
    this.payDollar(data);
    //window.location = `./tempOrderSuccessPage/${ctId}`;
  }
  tempOrderFailByOutOfStock() {
    //pop up 提示返回購物袋
    this.setState({
      showTempOrderFailByOutOfStock: true
    });
  }
  tempOrderFail() {
    //pop up 訂單建立失敗
    this.setState({
      showTempOrderFail: true
    });
  }

  closeTempOrderFailByOutOfStock() {
    // 關閉第三步驟
    $(".checkout_payment").removeClass("opened");
    const step3 = $(".sectContent.step3");
    step3.css("display", "none");
    // 開啟第一步驟
    $(".checkout_deliver").removeClass("filled");
    $(".checkout_pdts").addClass("opened");
    $(".checkout_pdts .sectContent").slideDown(300);
    $(".sidebar_forSticky .checkout_discountCode_wrap").removeClass("hide");
    this.setState({
      showTempOrderFailByOutOfStock: false
    });
  }
  closeTempOrderFail() {
    this.setState({
      showTempOrderFail: false
    });
  }
  insiderFun() {
    if (window.insider_object && window.Insider) {
      window.Insider.fns.isFunction(
        window.Insider.__external.confirmationInterval130496
      ) && clearInterval(window.Insider.__external.confirmationInterval130496);
      window.insider_object = {
        page: {
          type: "Confirmation"
        }
      };
      window.Insider.__external.confirmationInterval130496 = setInterval(
        function () {
          if (
            (((window.insider_object || {}).page || {}).type || "") ===
            "Confirmation"
          ) {
            window.Insider.eventManager.dispatch("init-manager:re-initialize");
            console.log("INSIDER_PAGE_TYPE_CONFIRMATION");
            fetch("/INSIDER_PAGE_TYPE_CONFIRMATION");
            clearInterval(window.Insider.__external.confirmationInterval130496);
          }
        },
        300
      );
    }
  }
  getOrderData() {
    let orderData;

    if (this.state.deliverOption_btn_active) {
      // 使用分店取貨
      const {
        pickup_customerName,
        pickup_customerTitle,
        pickup_phoneCode,
        pickup_phoneNo,
        pickup_stores
      } = this.state.pickupOption;

      orderData = {
        earmarkIds: [],
        rcptFirstNam: pickup_customerName.value,
        rcptLastNam: "",
        rcptMobCtryCde: pickup_phoneCode.value,
        rcptMobNbr: pickup_phoneNo.value,
        rcptSl: pickup_customerTitle.value,
        storeId: pickup_stores.value,
        payMethod: this.state.paymentMethod,
        addressId: null
      };
    } else {
      // 使用宅配
      const {
        delivery_customerName,
        delivery_customerTitle,
        delivery_phoneCode,
        delivery_phoneNo,
        delivery_address_radioGrp
      } = this.state.deliveryOption;
      orderData = {
        earmarkIds: [],
        rcptFirstNam: delivery_customerName.value,
        rcptLastNam: "",
        rcptMobCtryCde: delivery_phoneCode.value,
        rcptMobNbr: delivery_phoneNo.value,
        rcptSl: delivery_customerTitle.value,
        storeId: null,
        deliveryMode: "PRI",
        senderPayDutytax: false,
        payMethod: this.state.paymentMethod,
        addressId: delivery_address_radioGrp.value
      };
    }

    if (this.state.paymentMethod === "stripeCard" && this.state.stripeTrade) {
      const { activeCardId, saveCard, cardEvent, stripeTrade, stripeCards } =
        this.state;
      const brand = {
        visa: "VISA",
        mastercard: "Master",
        amex: "AMEX",
        unionpay: "UPOP",
        jcb: "JCB"
      };
      const useActiveCard = activeCardId !== null;
      const _setupFutureUsage = useActiveCard ? false : saveCard;
      let activeCardBrand;
      if (stripeCards && isArray(stripeCards.cards)) {
        const activeCard = stripeCards.cards.find(
          data => data.stripePaymentMethodId === activeCardId
        );
        if (activeCard) activeCardBrand = activeCard.cardType;
      }
      const brand2 = {
        VISA: "VISA",
        MASTERCARD: "Master",
        AMEX: "AMEX",
        UNIONPAY: "UPOP",
        JCB: "JCB"
      };
      const _payMethod = useActiveCard
        ? brand2[activeCardBrand]
        : brand[cardEvent.brand];
      orderData = {
        ...orderData,
        stripePaymentId: stripeTrade.stripePaymentId,
        payMethod: _payMethod,
        stripeSetupFutureUsage: _setupFutureUsage
      };
    }

    return orderData;
  }
  postTempOrders = async () => {
    this.props.startLoading(true);
    try {
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/temp-orders`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.getOrderData()),
          credentials: "include"
        }
      );
      if (response.status == 201) {
        //POST temp-orders 成功
        this.insiderFun();
        this.setState({
          disableBuyButton: true
        });
        const data = await response.json();
        if (this.state.paymentMethod === "stripeCard") {
          // stripe payment
          const { stripeTrade, billingName, activeCardId } = this.state;
          let _payment_method;
          if (activeCardId) {
            // 使用已儲存的卡片付款
            _payment_method = activeCardId;
          } else {
            // 使用目前的信用卡付款
            _payment_method = {
              card: cardNumber,
              billing_details: {
                name: billingName
              }
            };
          }
          stripe
            .confirmCardPayment(stripeTrade.stripeClientSecret, {
              payment_method: _payment_method,
              return_url: data.successUrl
            })
            .then(result => {
              this.props.startLoading(false);
              this.setState({
                disableBuyButton: false
              });
              if (result.error) {
                const _errorMessages =
                  this.props.lang === "en"
                    ? stripeErrorMessageEn
                    : stripeErrorMessageTc;
                const _message = _errorMessages[result.error.code];
                this.setState({
                  stripeErrorText: _message || result.error.message
                });
                this.putTempOrders(data.ctId);
              } else {
                window.location = data.successUrl;
              }
            });
        } else {
          this.goToSuccessPage(data);
        }
      } else {
        //POST temp-otders 失敗
        const data = await response.json();
        //失敗 -> 庫存賣完
        if (data.hasOwnProperty("errors")) {
          data.errors.forEach(element => {
            if (element.errorCode === "E00949") {
              // 顯示庫存不足
              this.tempOrderFailByOutOfStock();
              // 重新取得myBag
              this.props.fetchMyBag();
              // 取得庫存不足的商品資訊
              const message = JSON.parse(element.message);
              this.setState({
                stockData: message
              });
            }
          });
        } else {
          // 顯示訂單建立失敗
          this.tempOrderFail();
          //失敗-> 其他errorCode
          throw new Error("others-erroe-code");
        }
        //失敗 -> 建立temp oreder失敗
        throw new Error("fetch-temp-order-failed");
      }
    } catch (err) {
      this.setState({
        disableBuyButton: false
      });
      this.props.startLoading(false);
    }
  };
  putTempOrders = async ctId => {
    try {
      this.props.startLoading(true);
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/orders`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ ctId: ctId }),
          credentials: "include"
        }
      );
      if (response.ok) {
        const pathLang = this.props.lang === "en" ? "en" : "tc";
        window.location = `/eshop-hk/${pathLang}/resultFail`;
      } else {
        throw new Error("PUT_TEMP_ORDERS_FAILED");
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.props.startLoading(false);
    }
  };
  async buy() {
    //檢查paymentMethod
    if (this.state.paymentMethod === "") {
      //顯示錯誤提示
      this.setState({
        ...this.state,
        paymentMethodError: true
      });
      //捲動至標題
      const title = document.getElementById("step3-title");
      window.scrollTo({ top: title.offsetTop, behavior: "smooth" });
      //禁止立即購買按鈕
      return;
    }
    //隱藏錯誤提示
    this.setState({
      ...this.state,
      paymentMethodError: false,
      disableBuyButton: true
    });
    if (this.state.paymentMethod === "PAYPAL") {
    }
    //開啟立即購買按鈕
    if (this.state.paymentMethod === "stripeCard") {
      await this.handleSubmitStripe();
    } else {
      await this.postTempOrders();
    }
    setGAEvent("add_payment_info", this.props.myBagData, {
      paymentType: this.state.paymentMethod,
      shippingTier: this.state.deliverOption_btn_active
    });
  }

  handleSubmitStripe = async () => {
    this.setState({
      stripeErrorText: null
    });
    const { billingName, cardEvent, activeCardId } = this.state;
    const { lang } = this.props;
    if (activeCardId) {
      this.postTempOrders();
      return;
    }
    if (billingName.trim() !== "") {
      if (
        ["visa", "mastercard", "amex", "unionpay", "jcb"].includes(
          cardEvent.brand
        )
      ) {
        try {
          this.props.startLoading(true);
          if (this.state.cardEvent.complete) {
            this.postTempOrders();
          } else {
            // 等待500ms再執行, 是確認cardEvent要拿到更新後的值
            setTimeout(() => {
              if (this.state.cardEvent.error) {
                const _errorMessages =
                  lang === "en" ? stripeErrorMessageEn : stripeErrorMessageTc;
                const _message =
                  _errorMessages[this.state.cardEvent.error.code];
                this.setState({
                  stripeErrorText: _message || cardEvent.error.message,
                  disableBuyButton: false
                });
              } else {
                this.setState({
                  stripeErrorText:
                    lang === "en"
                      ? "Please enter valid credit card numbers."
                      : "請輸入有效的信用卡號碼。",
                  disableBuyButton: false
                });
              }
            }, 500);
            this.props.startLoading(false);
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        this.setState({
          stripeErrorText:
            lang === "en"
              ? "The entered credit card can not be used, please enter a new credit card. "
              : "很抱歉, 您輸入的信用卡無法在此次付款中使用, 請輸入另一張信用卡。",
          disableBuyButton: false
        });
      }
    } else {
      this.setState({
        stripeErrorText:
          lang === "en" ? "Please enter cardholder name" : "請輸入持卡人姓名",
        disableBuyButton: false
      });
    }
  };

  cancelEditAddress = () => {
    // 編輯地址與新增地址的取消按鈕事件，恢復deliveryOption的state值為目前選取地址的值
    const addressId = this.state.deliveryOption.delivery_address_radioGrp;
    if (addressId.value) {
      const { addressData } = this.props;
      const activeAddress = addressData._embedded.addresses.find(
        data => data.id === addressId.value
      );
      const {
        address1,
        address2,
        city,
        countryCode,
        postCode,
        province,
        rcptFirstNam,
        rcptMobCtryCde,
        rcptMobNbr,
        rcptSl
      } = activeAddress;

      const editedDeliveryOption = {
        ...this.state.deliveryOption,
        delivery_addressLine1: { value: address1, error: false },
        delivery_addressLine2: { value: address2, error: false },
        delivery_address_radioGrp: {
          value: addressId.value,
          error: false
        },
        delivery_area: { value: countryCode, error: false },
        delivery_city: { value: city, error: false },
        delivery_customerName: {
          value: rcptFirstNam,
          error: false
        },
        delivery_customerTitle: { value: rcptSl, error: false },
        delivery_district: { value: province, error: false },
        delivery_mode_radioGrp: true,
        delivery_phoneCode: { value: rcptMobCtryCde, error: false },
        delivery_phoneNo: { value: rcptMobNbr, error: false },
        delivery_postcode: { value: postCode, error: false }
      };
      this.setState({
        deliveryOption: editedDeliveryOption
      });
    }
  };
  handleClickPaymentBtn(name) {
    this.setState({
      ...this.state,
      paymentMethod: name
    });
  }
  setStockData(message) {
    this.setState({
      stockData: message
    });
  }
  proxyPaymentMethod(paymentMethods, IsStoreDelivery) {
    let result = paymentMethods;
    if (IsStoreDelivery) {
      result = paymentMethods.filter(payment => payment.name !== "PAYPAL");
    }
    return result;
  }

  async handlePaymentSection(data) {
    const { stripeTrade, stripeCards } = this.state;
    await this.setState({
      activePaymentSection: data.value,
      paymentMethod: data.value
    });
    if (data.value === "stripeCard") {
      if (stripeTrade === null) {
        // 先執行POST /stripe/trade
        this.postStripeTrade();
      } else {
        const element = document.getElementById("addCreditCard");
        if (stripeCards && isArray(stripeCards.cards)) {
          const activeCard = stripeCards.cards[0];
          this.setState({ activeCardId: activeCard.stripePaymentMethodId });
          element.style.display = "none";
        } else {
          element.style.display = "block";
          this.setState({
            activeCardId: null
          });
        }
      }
    } else {
      const element = document.getElementById("addCreditCard");
      element.style.display = "none";
    }
  }

  postStripeTrade = async () => {
    try {
      this.props.startLoading(true);
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/stripe/trades`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ payMethod: "CARD" }),
          credentials: "include"
        }
      );
      if (response.status === 201) {
        const result = await response.json();
        this.setState({ stripeTrade: result });
        const { stripePublicKey } = result;
        stripe = window.Stripe(stripePublicKey);
        const locale = this.props.lang === "en" ? "en" : "zh-HK";
        const elements = stripe.elements({ locale });
        const style = {
          base: {
            fontSize: "13px",
            fontWeight: "300",
            fontFamily: "Times New Roman, Times, serif",
            "::placeholder": {
              color: "#7f7f7f",
              fontFamily: "Times New Roman, Times, serif"
            }
          }
        };
        cardNumber = elements.create("cardNumber", {
          style,
          showIcon: true,
          placeholder: this.props.lang === "en" ? "Card Number" : "卡號"
        });
        cardNumber.mount("#payment-stripe-cardNumber");
        cardNumber.on("change", event => {
          this.setState({
            cardEvent: event
          });
        });
        cardExpiry = elements.create("cardExpiry", { style });
        cardExpiry.mount("#payment-stripe-cardExpiry");
        cardExpiry.on("change", event => {
          this.setState({
            cardEvent: { brand: this.state.cardEvent.brand, ...event }
          });
        });
        cardCvc = elements.create("cardCvc", { style });
        cardCvc.mount("#payment-stripe-cardCvc");
        cardCvc.on("change", event => {
          this.setState({
            cardEvent: { brand: this.state.cardEvent.brand, ...event }
          });
        });
        this.getStripeCards();
      } else {
        // 提示訂單錯誤訊息
        this.setState({
          showTempOrderFail: true
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.props.startLoading(false);
    }
  };

  getStripeCards = async () => {
    this.props.startLoading(true);
    try {
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/stripe/paymentMethods`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        }
      );
      if (response.ok) {
        const result = await response.json();
        this.setState({
          stripeCards: result
        });
        if (isArray(result.cards)) {
          // 使用已儲存過的卡片
          const activeCard = result.cards[0];
          this.setState({
            activeCardId: activeCard.stripePaymentMethodId
          });
          const element = document.getElementById("addCreditCard");
          element.style.display = "none";
        } else {
          const element = document.getElementById("addCreditCard");
          element.style.display = "block";
          this.setState({
            activeCardId: null
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.props.startLoading(false);
    }
  };

  deleteStripePaymentMethodId = async stripePaymentMethodId => {
    try {
      this.props.startLoading(true);
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/stripe/paymentMethod/${stripePaymentMethodId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        }
      );
      if (response.ok) {
        this.getStripeCards();
        this.setState({
          saveCardErrorText: false
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.props.startLoading(false);
    }
  };

  handleCard = id => {
    const element = document.getElementById("addCreditCard");
    element.style.display = "none";
    this.setState({ activeCardId: id });
  };

  handleAddCard = () => {
    const element = document.getElementById("addCreditCard");
    element.style.display = "block";
    this.setState({ activeCardId: null });
  };

  _cardBrandImg = brand => {
    const images = {
      VISA: visaSvg,
      MASTERCARD: masterSvg,
      AMEX: amexSvg,
      UNIONPAY: unionSvg,
      JCB: paymentJCB
    };
    return images[brand] || "";
  };

  render() {
    const paymentMethodList = this.proxyPaymentMethod(
      [
        { name: "VISA", imgSrc: paymentVisa },
        { name: "Master", imgSrc: paymentMastercard },
        { name: "PAYPAL", imgSrc: paymentPaypal }
      ],
      this.state.deliverOption_btn_active
    );

    const paymentMethodListForUAT = this.proxyPaymentMethod(
      [
        { name: "VISA", imgSrc: paymentVisa },
        { name: "Master", imgSrc: paymentMastercard },
        { name: "PAYPAL", imgSrc: paymentPaypal },
        { name: "ALIPAY", imgSrc: paymentAlipay },
        { name: "AMEX", imgSrc: paymentAe }
      ],
      this.state.deliverOption_btn_active
    );

    const paymentSections = [
      {
        name: <Translation>{t => <>{t("checkout.creditCard")}</>}</Translation>,
        value: "stripeCard",
        img: 
        <div className="payment_sections_img_wrap">
          <img src={paymentJCB} className="jcb" alt="" />
          <img src={paymentStripe} className="stripe" alt="" />
        </div>
      },
      {
        name: <Translation>{t => <>{t("checkout.aliPay")}</>}</Translation>,
        value: "ALIPAY",
        img: <img src={paymentAlipay} alt="" />

      },
      {
        name: <Translation>{t => <>{t("checkout.paypal")}</>}</Translation>,
        value: "PAYPAL",
        img: <img src={paymentPaypal} alt="" />

      }
    ];

    const { getMyBagSuccessfully, myBagData, lang, isLogin } = this.props;
    const {
      pickupOption,
      deliveryOption,
      places,
      showTempOrderFailByOutOfStock,
      showTempOrderFail,
      tempOrderResponseData,
      paymentMethodError,
      paymentMethod,
      CheckEmailDisplayStatus,
      stockData,
      stripeTrade,
      activeCardId,
      saveCard,
      stripeCards
    } = this.state;

    return (
      <>
        {/* 庫存不足POP-UP */}
        {showTempOrderFailByOutOfStock && (
          <TempOrderErrorPopup
            lang={lang}
            text={
              <Translation>
                {t => <>{t("errorPopup.insufficientStock")}</>}
              </Translation>
            }
            closeTempOrderFailByOutOfStock={this.closeTempOrderFailByOutOfStock.bind(
              this
            )}
            stockData={stockData}
          />
        )}
        {/* 訂單建立失敗POP-UP */}
        {showTempOrderFail && (
          <TempOrderErrorPopup
            text={
              <Translation>
                {t => <>{t("errorPopup.orderFailed")}</>}
              </Translation>
            }
            closeTempOrderFailByOutOfStock={this.closeTempOrderFail.bind(this)}
          />
        )}
        <section className="checkout_sect checkout_pdts opened">
          <div className="sectTitle step1">
            <span className="num">1</span>
            <Translation>{t => <>{t(`checkout.myBag`)}</>}</Translation>
            (
            <ShoppingBagNum />
            {/* <span className="shoppingBagNum">
              {getMyBagSuccessfully && myBagData.cartItems.length}
            </span> */}
            )
            <hr />
          </div>

          <div className="sectContent pdt_wrap">
            <PdtWrap
              deliveryOption={deliveryOption}
              pickupOption={pickupOption}
              deliverOption_btn_active={this.state.deliverOption_btn_active}
            />

            {isArray(myBagData.coupons) &&
              myBagData.coupons.map(
                (data, index) =>
                  data.giftIndicator && (
                    <div key={index} className="pdt_wrap row no-gutters">
                      <div className="col-4 col-md-3 thm_col_wrap">
                        <img src={data.imageUrl} alt="" />
                      </div>
                      <div className="col-5 col-md-4 details_col_wrap">
                        <div className="name_wrap">
                          <div className="collectionName">
                            {data.couponName}
                          </div>
                        </div>
                        <div className="details_wrap">
                          <div>
                            <Translation>
                              {t => <>{t(`checkout.couponQuantity`)}</>}
                            </Translation>
                          </div>
                          <div className="services">
                            <Translation>
                              {t => <>{t(`checkout.couponTnc`)}</>}
                            </Translation>
                          </div>
                        </div>
                      </div>
                      <div className="col-0 col-md-2 notes notes_col_wrap"></div>
                      <div className="col-4 col-md-3 price_col_wrap">
                        <div className="price">
                          <Translation>
                            {t => <>{t(`checkout.couponFree`)}</>}
                          </Translation>
                        </div>
                      </div>
                    </div>
                  )
              )}

            {/* 購物袋沒有任何貨品則顯示 */}
            <EmptyBag />
            <div className="checkout-right_wrap right_wrap_m d-block d-md-none">
              <div className="content">
                <OrderSummary />
                {isLogin ? (
                  <div>
                    <a
                      className="openModelMobile_btn"
                      data-toggle="modal"
                      data-target="#modal_discountCode"
                    >
                      <Translation>
                        {t => <>{t(`checkout.useCoupon`)}</>}
                      </Translation>
                      <button
                        className="go_btn"
                        tabIndex="0"
                        role="button"
                        aria-label="New overlay"
                      ></button>
                    </a>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="buttons_wrap">
              <div>
                <Translation>
                  {t => (
                    <a
                      id="checkout_contShopping_btn"
                      className="blockBtn grey"
                      href={lang === "en" ? "/en/home" : "/tc/home "}
                    >
                      {t(`checkout.continueShopping`)}
                    </a>
                  )}
                </Translation>
                <BtnCheckLogin
                  clickLogin={this.clickLogin.bind(this)}
                  clickNextButtonForCheckEmail={this.clickNextButtonForCheckEmail.bind(
                    this
                  )}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="checkout_sect checkout_deliver step2">
          <div className="sectTitle step2" id="step2-title">
            <span className="num">2</span>
            <Translation>{t => t("checkout.delivery")}</Translation>
            <hr />
          </div>

          <div className="sectContent step2" id="step2-sect-content">
            <div className="options_wrap row no-gutters with-gaps">
              <div className="col-6 pickup_col_wrap">
                <button
                  className="deliverOption_btn active"
                  data-optioncontent=".checkout_deliver .pickup_wrap"
                  onClick={this.clickPickStoreBtn.bind(this)}
                >
                  <div className="content">
                    <div className="icon_wrap">
                      <img
                        className="icon"
                        src={
                          this.state.deliverOption_btn_active
                            ? checkoutInstoreActive
                            : checkoutInstore
                        }
                        alt=""
                      />
                    </div>
                    <div className="txts_wrap">
                      <Translation>
                        {t => (
                          <div className="optionName">
                            {t("checkout.inStoreCollection")}
                          </div>
                        )}
                      </Translation>

                      <Translation>
                        {t => (
                          <div className="option-text">
                            {t("checkout.Complimentary")}
                            <br />
                            {t("checkout.HKOnly")}
                          </div>
                        )}
                      </Translation>
                    </div>
                  </div>
                </button>
              </div>
              <div className="col-6 delivery_col_wrap">
                <button
                  className="deliverOption_btn"
                  data-optioncontent=".checkout_deliver .delivery_wrap"
                  onClick={this.clickDeliveryBtn.bind(this)}
                >
                  <div className="content">
                    <div className="icon_wrap">
                      <img
                        className="icon"
                        src={
                          this.state.deliverOption_btn_active
                            ? checkoutLocalDelivery
                            : checkoutLocalDeliveryActive
                        }
                        alt=""
                      />
                    </div>
                    <div className="txts_wrap">
                      <Translation>
                        {t => (
                          <div className="optionName">
                            {t("checkout.deliveryServer")}
                          </div>
                        )}
                      </Translation>
                      <Translation>
                        {t => (
                          <div className="option-text">
                            {t("checkout.HKComplimentary")}
                            <br />
                            {t("checkout.internationalCharges")}
                          </div>
                        )}
                      </Translation>
                    </div>
                  </div>
                </button>
              </div>
            </div>
            <StoreForm
              pickupOption={pickupOption}
              handlePickupChange={this.handlePickupChange.bind(this)}
              clickNextBtnOfPickup={this.clickNextBtnOfPickup.bind(this)}
            />

            <div className="delivery_wrap">
              <AddressFrom
                deliveryOption={deliveryOption}
                handleDeliveryChange={this.handleDeliveryChange.bind(this)}
                places={places}
                cancelEditAddress={this.cancelEditAddress.bind(this)}
                saveAdd={this.saveAdd.bind(this)}
              />
              {/* <div className="delivery_newAddress_wrap">
                <Translation>
                  {t => (
                    <div className="subtitle subtitle_sect">
                      {t("checkout.shippingAddress")}
                    </div>
                  )}
                </Translation>
                <div className="delivery_addressForm_wrap">
                  <div className="row no-gutters with-gaps">
                    <div className="col-12 col-md-6 clearfix">
                      <div className="narrowerInput_wrap">
                        <p>
                          <select
                            id="delivery_customerTitle"
                            name="delivery_customerTitle"
                            required
                            value={
                              this.state.deliveryOption.delivery_customerTitle
                                .value
                            }
                            onChange={this.handleDeliveryChange.bind(this)}
                            className={this.proxyErrorStyle(
                              deliveryOption.delivery_customerTitle.error
                            )}
                          >
                            <Translation>
                              {t => (
                                <>
                                  <option value="">
                                    {t("checkout.title")}
                                  </option>
                                  <option value="03">{t("checkout.ms")}</option>
                                  <option value="01">{t("checkout.mr")}</option>
                                  <option value="02">
                                    {t("checkout.miss")}
                                  </option>
                                </>
                              )}
                            </Translation>
                          </select>
                          {this.proxyErrorText(
                            deliveryOption.delivery_customerTitle.error
                          )}
                        </p>
                      </div>
                      <div className="widerInput_wrap">
                        <p>
                          <Translation>
                            {t => (
                              <input
                                type="text"
                                id="delivery_customerName"
                                name="delivery_customerName"
                                placeholder={t("checkout.name")}
                                required
                                value={
                                  this.state.deliveryOption
                                    .delivery_customerName.value
                                }
                                onChange={this.handleDeliveryChange.bind(this)}
                                className={this.proxyErrorStyle(
                                  deliveryOption.delivery_customerName.error
                                )}
                              />
                            )}
                          </Translation>
                          {this.proxyErrorText(
                            deliveryOption.delivery_customerName.error
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 clearfix">
                      <div className="narrowerInput_wrap">
                        <p>
                          <select
                            id="delivery_phoneCode"
                            name="delivery_phoneCode"
                            className="narrowerInput"
                            required
                            value={
                              this.state.deliveryOption.delivery_phoneCode.value
                            }
                            onChange={this.handleDeliveryChange.bind(this)}
                          >
                            <option value="852">+852</option>
                            <option value="86">+86</option>
                            <option value="886">+886</option>
                            <option value="853">+853</option>
                          </select>
                        </p>
                      </div>
                      <div className="widerInput_wrap">
                        <p>
                          <Translation>
                            {t => (
                              <input
                                type="text"
                                id="delivery_phoneNo"
                                name="delivery_phoneNo"
                                placeholder={t("checkout.phone")}
                                required
                                value={
                                  this.state.deliveryOption.delivery_phoneNo
                                    .value
                                }
                                onChange={this.handleDeliveryChange.bind(this)}
                                className={this.proxyErrorStyle(
                                  deliveryOption.delivery_phoneNo.error
                                )}
                              />
                            )}
                          </Translation>
                          {this.proxyErrorText(
                            deliveryOption.delivery_phoneNo.error
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <p>
                    <Translation>
                      {t => (
                        <input
                          type="text"
                          id="delivery_addressLine1"
                          name="delivery_addressLine1"
                          placeholder={t("checkout.address1")}
                          required
                          value={
                            this.state.deliveryOption.delivery_addressLine1
                              .value
                          }
                          onChange={this.handleDeliveryChange.bind(this)}
                          className={this.proxyErrorStyle(
                            deliveryOption.delivery_addressLine1.error
                          )}
                        />
                      )}
                    </Translation>
                    {this.proxyErrorText(
                      deliveryOption.delivery_addressLine1.error
                    )}
                  </p>
                  <p>
                    <Translation>
                      {t => (
                        <input
                          type="text"
                          id="delivery_addressLine2"
                          name="delivery_addressLine2"
                          placeholder={t("checkout.address2")}
                          value={
                            this.state.deliveryOption.delivery_addressLine2
                              .value === null
                              ? ""
                              : this.state.deliveryOption.delivery_addressLine2
                                  .value
                          }
                          required
                          onChange={this.handleDeliveryChange.bind(this)}
                        />
                      )}
                    </Translation>
                  </p>
                  <div className="row no-gutters with-gaps">
                    <div className="col-12 col-md-6">
                      <p>
                        <select
                          id="delivery_area"
                          name="delivery_area"
                          className={this.proxyErrorStyle(
                            deliveryOption.delivery_area.error,
                            "narrowerInput"
                          )}
                          required
                          value={this.state.deliveryOption.delivery_area.value}
                          onChange={this.handleDeliveryChange.bind(this)}
                        >
                          <Translation>
                            {t => (
                              <option value="">
                                {t("checkout.chooseCountry")}
                              </option>
                            )}
                          </Translation>                          
                        </select>
                        {this.proxyErrorText(
                          deliveryOption.delivery_area.error
                        )}
                      </p>
                    </div>
                  </div>
                  {!this.isHK() && (
                    <div className="row no-gutters with-gaps">
                      <div className="col-12 col-md-6">
                        <p>
                          <>
                            <Translation>
                              {t => (
                                <input
                                  type="text"
                                  id="delivery_postcode"
                                  name="delivery_postcode"
                                  placeholder={t("checkout.postcode")}
                                  required
                                  value={
                                    this.state.deliveryOption.delivery_postcode
                                      .value
                                  }
                                  onChange={this.handleDeliveryChange.bind(
                                    this
                                  )}
                                  className={this.proxyErrorStyle(
                                    deliveryOption.delivery_postcode.error
                                  )}
                                />
                              )}
                            </Translation>
                            {this.proxyErrorText(
                              deliveryOption.delivery_postcode.error
                            )}
                          </>
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="row no-gutters with-gaps">
                    <div className="col-12 col-md-6">
                      <p>
                        {places.items && places.items.length > 0 ? (
                          <select
                            id="delivery_district"
                            name="delivery_district"
                            className={this.proxyErrorStyle(
                              deliveryOption.delivery_district.error,
                              "narrowerInput"
                            )}
                            required
                            value={
                              this.state.deliveryOption.delivery_district.value
                            }
                            onChange={this.handleDeliveryChange.bind(this)}
                          >
                            {this.isHK() ? (
                              <Translation>
                                {t => (
                                  <option value="">
                                    {t("checkout.stateHK")}
                                  </option>
                                )}
                              </Translation>
                            ) : (
                              <Translation>
                                {t => (
                                  <option value="">
                                    {t("checkout.state")}
                                  </option>
                                )}
                              </Translation>
                            )}
                            {places.items &&
                              places.items.length > 0 &&
                              places.items.map((area, index) => (
                                <option value={area.name} key={index}>
                                  {area.name}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <Translation>
                            {t => (
                              <input
                                type="text"
                                id="delivery_district"
                                name="delivery_district"
                                placeholder={t("checkout.state")}
                                required
                                value={
                                  this.state.deliveryOption.delivery_district
                                    .value
                                }
                                onChange={this.handleDeliveryChange.bind(this)}
                                className={this.proxyErrorStyle(
                                  deliveryOption.delivery_district.error
                                )}
                              />
                            )}
                          </Translation>
                        )}
                        {places.items && places.items.length > 0
                          ? this.proxyErrorText(
                              deliveryOption.delivery_district.error
                            )
                          : this.proxyErrorText(
                              deliveryOption.delivery_district.error
                            )}
                      </p>
                    </div>
                  </div>
                  <div className="row no-gutters with-gaps">
                    <div className="col-12 col-md-6">
                      <p>
                        {this.hasCity(places, deliveryOption) ? (
                          <select
                            id="delivery_city"
                            name="delivery_city"
                            className={this.proxyErrorStyle(
                              deliveryOption.delivery_city.error,
                              "narrowerInput"
                            )}
                            required
                            value={
                              this.state.deliveryOption.delivery_city.value
                            }
                            onChange={this.handleDeliveryChange.bind(this)}
                          >
                            {this.isHK() ? (
                              <Translation>
                                {t => (
                                  <option value="">
                                    {t("checkout.cityHK")}
                                  </option>
                                )}
                              </Translation>
                            ) : (
                              <Translation>
                                {t => (
                                  <option value="">{t("checkout.city")}</option>
                                )}
                              </Translation>
                            )}

                            {places.items &&
                              places.items.length > 0 &&
                              places.items.map((area, index) => {
                                if (
                                  area.name ===
                                  deliveryOption.delivery_district.value
                                ) {
                                  return (
                                    area.subitems &&
                                    area.subitems.length > 0 &&
                                    area.subitems.map((district, index) => (
                                      <option value={district.name} key={index}>
                                        {district.name}
                                      </option>
                                    ))
                                  );
                                }
                                return null;
                              })}
                          </select>
                        ) : (
                          <Translation>
                            {t => (
                              <input
                                type="text"
                                id="delivery_city"
                                name="delivery_city"
                                placeholder={t("checkout.city")}
                                required
                                value={
                                  this.state.deliveryOption.delivery_city.value
                                }
                                onChange={this.handleDeliveryChange.bind(this)}
                                className={this.proxyErrorStyle(
                                  deliveryOption.delivery_city.error
                                )}
                              />
                            )}
                          </Translation>
                        )}
                        {places.items && places.items.length > 0
                          ? this.proxyErrorText(
                              deliveryOption.delivery_city.error
                            )
                          : this.proxyErrorText(
                              deliveryOption.delivery_city.error
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="buttons_wrap">
                  <div>
                    <Translation>
                      {t => (
                        <>
                          <a
                            id="cancelSaveAdd_btn"
                            className="blockBtn grey"
                            href="javascript:void(0)"
                            onClick={this.cancelEditAddress}
                          >
                            {t("checkout.cancel")}
                          </a>
                          <a
                            id="saveAdd_btn"
                            className="blockBtn"
                            onClick={this.saveAdd.bind(this)}
                          >
                            {t("checkout.saveAddress")}
                          </a>
                        </>
                      )}
                    </Translation>
                  </div>
                </div>
              </div> */}

              <div className="delivery_details_wrap">
                <div className="row no-gutters with-gaps">
                  <div className="col-12 col-md-6">
                    <div className="part">
                      <div className="subtitle_withLine_wrap">
                        <Translation>
                          {t => (
                            <p className="subtitle shorter subtitle_sect">
                              {t("checkout.shippingAddress")}
                            </p>
                          )}
                        </Translation>
                        <hr />
                      </div>
                      <div className="radioBtns_wrap vertical">
                        <AddressList
                          deliveryOption={deliveryOption}
                          handleDeliveryChange={this.handleDeliveryChange.bind(
                            this
                          )}
                          clickEditAddress={this.clickEditAddress.bind(this)}
                          clickRemoveAddress={this.clickRemoveAddress.bind(
                            this
                          )}
                        />
                      </div>
                      <div>
                        {proxyErrorText(
                          deliveryOption.delivery_address_radioGrp.error,
                          <Translation>
                            {t => <>{t("checkout.chooseAddress")}</>}
                          </Translation>
                        )}
                      </div>
                      <br />
                      <div>
                        <Translation>
                          {t => (
                            <>
                              <a
                                id="newAdd_btn"
                                className="content-link"
                                onClick={this.clickNewAdd.bind(this)}
                                href="javascript:void(0)"
                              >
                                {t("checkout.addNewAddress")}
                              </a>
                              <p style={{marginTop: 12}}>{t("checkout.addressRestrictionNotice")}</p>
                            </>
                          )}
                        </Translation>
                      </div>
                      <div>
                        {proxyErrorText(
                          deliveryOption.delivery_addrList_empty,
                          <Translation>
                            {t => <>{t("checkout.addAddress")}</>}
                          </Translation>
                        )}
                      </div>
                    </div>
                  </div>
                  {["HK", "MO"].includes(
                    deliveryOption.delivery_area.value
                  ) ? null : (
                    <div className="col-12 col-md-6">
                      <div className="part">
                        <div className="subtitle_withLine_wrap">
                          <Translation>
                            {t => (
                              <p className="subtitle shorter subtitle_sect">
                                {t("checkout.shippingMethod")}
                              </p>
                            )}
                          </Translation>
                          <hr />
                        </div>
                        <div className="radioBtns_wrap vertical">
                          <ul>
                            <li
                              style={{
                                position: "relative"
                              }}
                            >
                              <input
                                type="radio"
                                id="delivery_mode1"
                                name="delivery_mode_radioGrp"
                                // onClick={this.clickDeliveryMode.bind(this)}
                                // checked={deliveryOption.delivery_mode_radioGrp}
                                defaultChecked={true}
                                readOnly
                              />
                              <label htmlFor="delivery_mode1">
                                <Translation>
                                  {t => <>{t("checkout.priorityDelivery")}</>}
                                </Translation>
                                {lang === "en" ? <br /> : null}
                                <DutyTax />
                                {/* {dutyTax.deliveryDate && (
                                  <span>({dutyTax.deliveryDate})</span>
                                )} */}
                              </label>
                              <Step2ShippingFee />
                              {/* <div className="step2-shipping-fee">
                                {myBagData.shippingFee}
                              </div> */}
                            </li>
                          </ul>
                        </div>
                      </div>
                      {getMyBagSuccessfully ? (
                        myBagData.estimatedDutyTax === "HK$0" ? null : (
                          <div className="part">
                            <div className="subtitle_withLine_wrap">
                              <Translation>
                                {t => (
                                  <p className="subtitle shorter subtitle_sect">
                                    {t("checkout.dutiesTaxesCharges")}
                                  </p>
                                )}
                              </Translation>
                              <hr />
                            </div>
                            <div className="radioBtns_wrap vertical">
                              <ul>
                                <li>
                                  <input
                                    type="radio"
                                    id="delivery_taxPay1"
                                    name="delivery_taxPay_radioGrp"
                                    onChange={this.handleDeliveryChange.bind(
                                      this
                                    )}
                                    defaultChecked={true}
                                    value="delivery_taxPay1"
                                  />
                                  <Translation>
                                    {t => (
                                      <label htmlFor="delivery_taxPay1">
                                        {t("checkout.payByRecipient")}
                                      </label>
                                    )}
                                  </Translation>
                                </li>
                                {/* <li>
                          <input
                            type="radio"
                            id="delivery_taxPay2"
                            name="delivery_taxPay_radioGrp"
                            onChange={this.handleDeliveryChange.bind(this)}
                            value="delivery_taxPay2"
                          />
                          <label htmlFor="delivery_taxPay2">寄件者預繳</label>
                        </li> */}
                              </ul>
                            </div>
                          </div>
                        )
                      ) : null}
                    </div>
                  )}
                </div>
                <div className="buttons_wrap flex_content">
                  <div>
                    <Translation>
                      {t => (
                        <>
                          <a
                            className="blockBtn grey goSectBtn backStep1"
                            data-gosect=".checkout_pdts"
                            href="javascript:void(0)"
                          >
                            {t("checkout.back")}
                          </a>
                          <a
                            className="blockBtn"
                            data-gosect=".checkout_payment"
                            href="javascript:void(0)"
                            onClick={this.clickNextBtnOfDelivery.bind(this)}
                          >
                            {t("checkout.next")}
                          </a>
                        </>
                      )}
                    </Translation>
                  </div>
                </div>
              </div>
            </div>

            <div className="checkout-right_wrap right_wrap_m d-block d-md-none">
              <div className="content">
                <OrderSummary />
              </div>
            </div>
          </div>
        </section>

        <section className="checkout_sect checkout_payment step3">
          <div className="sectTitle step3" id="step3-title">
            <span className="num">3</span>
            {""}
            <Translation>{t => <>{t("checkout.paymentMethod")}</>}</Translation>
            <hr />
          </div>
          <div className="sectContent step3">
            <div>
              {paymentSections.map((data, index) => (
                <div key={index} className="payment-section-wrap">
                  <div
                    className="payment-section-label"
                    onClick={() => {
                      this.handlePaymentSection(data);
                    }}
                  >
                    <div className="method-wrap">
                      <input
                        className="payment-section-radio"
                        type="radio"
                        checked={this.state.activePaymentSection === data.value}
                        readOnly
                      />
                      <div className="payment-radio-label" />
                    </div>
                    <div className="image-wrap">
                      {data.img}
                    </div>
                  </div>
                  {data.value === "stripeCard" &&
                    this.state.activePaymentSection === data.value && (
                      <>
                        {stripeCards && isArray(stripeCards.cards) && (
                          <div className="stripe-cards-section">
                            {stripeCards.cards.map((data, index) => (
                              <div
                                key={index}
                                className={`card-opt-wrap ${
                                  activeCardId === data.stripePaymentMethodId
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() => {
                                  this.handleCard(data.stripePaymentMethodId);
                                }}
                              >
                                <div className="card-right">
                                  <div className="card-brand-wrap">
                                    <img
                                      src={this._cardBrandImg(data.cardType)}
                                      alt=""
                                    />
                                  </div>
                                  <div className="card-info-wrap">
                                    <div className="card-name">
                                      {data.cardType} *{data.cardSubfix}
                                    </div>
                                    <div className="card-expire">
                                      <Translation>
                                        {t => t("checkout.expires")}
                                      </Translation>{" "}
                                      {data.expiredMonth}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="card-delete-wrap"
                                  onClick={() => {
                                    this.deleteStripePaymentMethodId(
                                      data.stripePaymentMethodId
                                    );
                                  }}
                                >
                                  <Translation>
                                    {t => t("checkout.delete")}
                                  </Translation>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {stripeCards && isArray(stripeCards.cards) && (
                          <div
                            className="use-add-card"
                            onClick={this.handleAddCard}
                          >
                            <img
                              src="//cdn.chowsangsang.com/eshop/hk/newweb/icon/credit-card-icon.jpg"
                              alt=""
                            />
                            <span>
                              <Translation>
                                {t => t("checkout.differentCard")}
                              </Translation>
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  <div id="addCreditCard">
                    {data.value === "stripeCard" &&
                      this.state.activePaymentSection === data.value && (
                        <div className="card-billing-name">
                          <input
                            type="text"
                            placeholder={
                              this.props.lang === "en"
                                ? "Cardholder's Name"
                                : "持卡人姓名"
                            }
                            value={this.state.billingName}
                            onChange={e => {
                              this.setState({ billingName: e.target.value });
                            }}
                          />
                        </div>
                      )}
                    {data.value === "stripeCard" && (
                      <div id="payment-stripe-element">
                        <div id="payment-stripe-cardNumber" />
                        <div className="expiry_cvc_container">
                          <div id="payment-stripe-cardExpiry" />
                          <div id="payment-stripe-cardCvc" />
                          <img
                            className="cvc-image-icon"
                            src="//cdn.chowsangsang.com/eshop/hk/newweb/icon/icon_cvv.jpg"
                            alt=""
                          />
                        </div>
                      </div>
                    )}
                    {data.value === "stripeCard" &&
                      this.state.activePaymentSection === data.value && (
                        <div>
                          {this.state.saveCardErrorText && (
                            <div className="save-card-error-text">
                              <Translation>
                                {t => t("checkout.saveCardErrorText")}
                              </Translation>
                            </div>
                          )}
                          <div
                            className="save-card-btn"
                            onClick={() => {
                              if (
                                stripeCards &&
                                isArray(stripeCards.cards) &&
                                stripeCards.cards.length >= 3
                              ) {
                                this.setState({ saveCardErrorText: true });
                              } else {
                                this.setState({
                                  saveCard: !saveCard,
                                  saveCardErrorText: false
                                });
                              }
                            }}
                          >
                            <div
                              className={`save-card-label ${
                                saveCard ? "active" : ""
                              }`}
                            />
                            <span>
                              <Translation>
                                {t => t("checkout.saveCard")}
                              </Translation>
                            </span>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              ))}
            </div>
            {this.state.stripeErrorText && (
              <div className="stripe-error-text">
                {this.state.stripeErrorText}
              </div>
            )}
            {/* <div>
              {ASIA_PAY_SHOW === "true" ? (
                <>
                  {paymentMethodListForUAT.map((method, index) => (
                    <a
                      key={index}
                      className={`paymentBtn ${
                        paymentMethod === method.name ? "active" : ""
                      } `}
                      value={method.name}
                      onClick={() => this.handleClickPaymentBtn(method.name)}
                    >
                      <img src={method.imgSrc} alt="" />
                    </a>
                  ))}
                </>
              ) : (
                <>
                  {paymentMethodList.map((method, index) => (
                    <a
                      key={index}
                      className={`paymentBtn ${
                        paymentMethod === method.name ? "active" : ""
                      } `}
                      value={method.name}
                      onClick={() => this.handleClickPaymentBtn(method.name)}
                    >
                      <img src={method.imgSrc} alt="" />
                    </a>
                  ))}
                </>
              )}
            </div> */}

            <p>
              {paymentMethodError && (
                <span className="text-error">
                  {" "}
                  <Translation>
                    {t => <>{t("checkout.paymentRequired")}</>}
                  </Translation>
                </span>
              )}
            </p>

            <div className="buttons_wrap">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <a
                  className="blockBtn grey goSectBtn backStep2"
                  data-gosect=".checkout_deliver"
                  href="javascript:void(0)"
                >
                  <Translation>{t => t("checkout.back")}</Translation>
                </a>
                {(paymentMethod === "PAYPAL" && (
                  <PayPalButtonWrap
                    lang={this.props.lang}
                    orderData={this.getOrderData()}
                    tempOrderFailByOutOfStock={this.tempOrderFailByOutOfStock.bind(
                      this
                    )}
                    tempOrderFail={this.tempOrderFail.bind(this)}
                    setStockData={this.setStockData.bind(this)}
                    fetchMyBag={this.props.fetchMyBag.bind(this)}
                  />
                )) || (
                  <button
                    id="buyNow"
                    className="blockBtn"
                    onClick={this.buy.bind(this)}
                    disabled={this.state.disableBuyButton}
                  >
                    <Translation>{t => t("checkout.placeOrder")}</Translation>
                  </button>
                )}
              </div>
            </div>

            <div className="checkout-right_wrap right_wrap_m d-block d-md-none">
              <div className="content">
                <OrderSummary />
              </div>
            </div>
          </div>
        </section>

        <ChangeDeliveryAddress
          deliveryOption={deliveryOption}
          clear={this.clearSelectAddress}
        />
        <PayForm tempOrderResponseData={tempOrderResponseData} />

        <CheckEmail
          CheckEmailDisplayStatus={CheckEmailDisplayStatus}
          closeCheckEmailPage={this.closeCheckEmailPage.bind(this)}
          closeCheckEmailButton={this.closeCheckEmailButton.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    addressData: state.addresses.addressesData,
    addresses: state.addresses.addressesData,
    myBagData: state.myBag.myBagData,
    getMyBagSuccessfully: state.myBag.getMyBagSuccessfully,
    isLogin: state.login.signed
  };
};

const mapDispatchToProps = () => {
  return {
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode),
    fetchCountryList: () => countryList.actions.fetchCountryList(),
    fetchCountryIncludeHK: () => countryList.actions.fetchCountryIncludeHK(),
    fetchMyBag: () => myBag.actions.fetchMyBag(),
    removeAddress: address => addresses.actions.removeAddress(address),
    fetchAddresses: () => addresses.actions.fetchAddresses(),
    newAddress: address => addresses.actions.newAddress(address),
    editAddress: (address, id) => addresses.actions.editAddress(address, id),
    startLoading: bool => loading.actions.startLoading(bool),
    fetchInStore: () => pickUpInStore.actions.fetchInStore(),
    showLoginPopup: bool => loginPopup.actions.showLoginPopup(bool),
    fetchCustomer: () => customer.actions.fetchCustomer()
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Collapse);
